/** First GraphQL error message of an Apollo error, or null (network errors, plain errors, nothing). */
export function backendErrorMessage(err: unknown): string | null {
  const first = (err as { graphQLErrors?: { message?: string }[] } | null | undefined)?.graphQLErrors?.[0]?.message;
  return typeof first === 'string' && first.length > 0 ? first : null;
}

/**
 * Message of a backend BadRequestException (NestJS maps it to BAD_USER_INPUT), or null.
 * Other GraphQL errors (e.g. raw Prisma failures) return null so the caller shows its own message.
 */
export function userErrorMessage(err: unknown): string | null {
  const first = (err as { graphQLErrors?: { message?: string; extensions?: { code?: string } }[] } | null | undefined)
    ?.graphQLErrors?.[0];
  return first?.extensions?.code === 'BAD_USER_INPUT' ? backendErrorMessage(err) : null;
}
